import _App from "../playmore/app"

class App extends _App {
  constructor() {
    super()
    this.preDefinedApps = {
      NETFLIX: "Netflix",
      USB: "Media",
      CHROMECAST: "Googlecast",
      YOUTUBE: "Youtube",
      PRIME: "Amazon",
      BROWSER: "Internet"
    }
  }
  _init = async () => {
    return super._init()
  }

  getList = async () => {
    try {
      const res = JSON.parse(playmore.platform.getInstalledApps())
      if (!res) return res

      const applist = []
      res.forEach(app => applist.push({ key: app.name, value: app.name }))

      const whitelist = applist.map(app => app.key)
      playmore.platform.whiteApps(whitelist.join())

      return applist
    } catch (err) {
      return _$.error(err)
    }
  }
  launch = async (app_id, param) => {
    if (!app_id) return false
    let promise = await _$.progress.create()
    __._event.preventFocus = false
    await __.platform.unfocusing()
    __._device.registerKeys([
      "KEYCODE_DPAD_UP",
      "KEYCODE_DPAD_DOWN",
      "KEYCODE_DPAD_LEFT",
      "KEYCODE_DPAD_RIGHT",
      "KEYCODE_DPAD_CENTER",
      "KEYCODE_BACK"
    ])

    /* Library Code */
    let res = false
    if (app_id === "Weather" && param) res = playmore.platform.openWeather(parseInt(param))
    else res = playmore.platform.openApp(app_id)

    if (!res) promise.reject()
    /* Library Code */

    return promise.done
  }
  close = async () => {
    return super.close()
  }
}

export default App
